(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.investor-address-form', ['pp.widgets-templates', 'pp.widgets.duo-group-dropdown', 'pp.services.core', 'pp.values.form-lists', 'pp.values.blocked-countries', 'pp.components.focus-first-error']);

var UPDATED_TIMEOUT_DELAY = 5000;

var FORM_NAME = 'investor-address';

// backend error code prefix for a refused address country, suffixed with the reason
var BLOCKED_COUNTRY_ERROR_PREFIX = 'investor.address.blocked-country.';

ngModule.directive('ppInvestorAddressForm', [function () {
    return {
        restrict: 'A',
        templateUrl: 'widgets/_angular/investor-address-form/investor-address-form.tpl.html',
        scope: {
            address: '<ppInvestorAddressForm',
            onSubmit: '&'
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: ['$scope', '$timeout', 'formLists', 'blockedCountries', 'ppTrack', function ($scope, $timeout, formLists, blockedCountries, ppTrack) {
            var vm = this;

            // -- initial state

            vm.form = {};

            vm.formData = formLists;

            vm.blockedCountry = false;
            vm.blockedCountryReason = null;

            // -- util functions

            // reason is one of blockedCountries.REASON_* (or a backend reason code), null when allowed
            function setBlockedCountry(reason) {
                vm.blockedCountryReason = reason || null;
                vm.blockedCountry = !!reason;
                if (vm.form && vm.form.$setValidity) {
                    vm.form.$setValidity('blockedCountry', !reason);
                }
            }

            function handleSuccess() {
                ppTrack.formSubmit(FORM_NAME);
                vm.updated = true;
                $timeout(function () {
                    vm.updated = false;
                }, UPDATED_TIMEOUT_DELAY);
            }

            function handleFailure(error) {
                var reason = error && error.reason;
                ppTrack.formError(FORM_NAME, reason);
                if (reason && reason.indexOf(BLOCKED_COUNTRY_ERROR_PREFIX) === 0) {
                    // the backend refused the country: show it on the country field, not as a generic failure
                    setBlockedCountry(reason.substring(BLOCKED_COUNTRY_ERROR_PREFIX.length));
                    vm.feedbackEnabled = true;
                } else {
                    vm.processingError = true;
                }
            }

            function handleFinally() {
                vm.processing = false;
            }

            // -- api

            vm.submit = function () {

                if (vm.form.$invalid) {
                    ppTrack.ngFormValidation(FORM_NAME, vm.form);
                    vm.feedbackEnabled = true;
                    return;
                }

                vm.processing = true;
                vm.processingError = false;
                vm.feedbackEnabled = false;

                var data = {
                    address: vm.address
                };

                vm.onSubmit(data)
                    .then(handleSuccess, handleFailure)
                    .finally(handleFinally);

            };

            // -- scope bindings

            $scope.$watch('vm.address.countryCode', function (val) {
                setBlockedCountry(blockedCountries.reasonFor(val));
            });

            // -- main

        }]
    };
}]);
})(window, window.angular);